/**
 * TabbedChrome — context flag set where a page renders under a tab strip
 * (the main window's tab 1, or an iframe tab in the main window / a tabbed
 * window). The tab already names the page, so when true:
 *   - PageHeader drops its eyebrow and title and keeps only what the page
 *     uniquely owns: leading control, description, actions, children, tabs
 *   - the shell-injected V2PageChrome bar (crumb + title) disappears entirely
 *
 * Unlike EmbeddedChrome it leaves scrolling and backgrounds alone. Phones have
 * no tab strip, so the flag is false there and pages keep their titles.
 */
import { createContext, useContext } from 'react'

export const TabbedChrome = createContext(false)

export function useTabbedChrome(): boolean {
  return useContext(TabbedChrome)
}
